import * as ng from 'angular';
import { FocusMe } from './focus-me.directive';


export const FocusMeModule: string =
    ng.module('focus-me', [
    ])
        .directive('focusMe', FocusMe)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/focus-me/focus-me.module.ts